"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntryType = exports.EntryName = void 0;
exports.getEntriesByName = getEntriesByName;
exports.getEntriesByType = getEntriesByType;
// eslint-disable-next-line no-shadow
var EntryType; // eslint-disable-next-line no-shadow

exports.EntryType = EntryType;

(function (EntryType) {
  EntryType["FIRST_INPUT"] = "first-input";
  EntryType["LARGEST_CONTENTFUL_PAINT"] = "largest-contentful-paint";
  EntryType["LAYOUT_SHIFT"] = "layout-shift";
  EntryType["LONG_TASK"] = "longtask";
  EntryType["MARK"] = "mark";
  EntryType["MEASURE"] = "measure";
  EntryType["NAVIGATION"] = "navigation";
  EntryType["PAINT"] = "paint";
})(EntryType || (exports.EntryType = EntryType = {}));

var EntryName;
exports.EntryName = EntryName;

(function (EntryName) {
  EntryName["FIRST_PAINT"] = "first-paint";
  EntryName["FIRST_CONTENTFUL_PAINT"] = "first-contentful-paint";
})(EntryName || (exports.EntryName = EntryName = {}));

function getEntriesByType(entryType) {
  var entries = [];

  if ('performance' in window && typeof performance.getEntriesByType === 'function') {
    entries = performance.getEntriesByType(entryType);
  }

  return entries;
}

function getEntriesByName(entryName) {
  var entries = [];

  if ('performance' in window && typeof performance.getEntriesByName === 'function') {
    entries = performance.getEntriesByName(entryName);
  }

  return entries;
}